import { CompetitionsClient } from "./competitionsClient";

export const competitionsClientStub: CompetitionsClient = {
  searchCompetitions: () => Promise.resolve({}),
};
